import { css } from '@emotion/react';
import { theme } from '../../theme/theme';

export const inputStyle = css`
  padding: ${theme.space.sm}px ${theme.space.md}px;
  border: 1px solid ${theme.color.border};
  border-radius: ${theme.radius.sm}px;
  background: ${theme.color.surface};
  color: ${theme.color.text};
  font-size: ${theme.fontSize.md}px;

  &::placeholder {
    color: ${theme.color.textMuted};
  }

  &:focus {
    outline: 2px solid ${theme.color.primary};
    outline-offset: -1px;
  }
`;
